import { render, staticRenderFns } from "./AccountantsLedgerMenu.vue?vue&type=template&id=4bef5bcf&scoped=true&"
import script from "./AccountantsLedgerMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsLedgerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef5bcf",
  null
  
)

export default component.exports